import service from '@/api/engagement';
import {loading, handleError} from '@/state/generators/helpers';

export const state = {
    loading: false,
    service: service('patient/me/engagement'),
    levelService: service('patient/engagement/levels'),
    profile: null,
    events: [],
    eventsMeta: null,
    rewards: [],
    rewardsMeta: null,
    levels: [],
    errors: {}
};

export const getters = {
    loading: function (state) {
        return !!state.loading;
    },
    profile: function (state) {
        return state.profile ? JSON.parse(JSON.stringify(state.profile)) : null;
    },
    events: function (state) {
        return state.events;
    },
    eventsMeta: function (state) {
        return state.eventsMeta;
    },
    rewards: function (state) {
        return state.rewards;
    },
    rewardsMeta: function (state) {
        return state.rewardsMeta;
    },
    levels: function (state) {
        return state.levels;
    }
};

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean;
    },
    'SET_PROFILE': function (state, profile = null) {
        state.profile = profile;
    },
    'SET_EVENTS': function (state, {data = [], meta = null} = {}) {
        state.events = data;
        state.eventsMeta = meta;
    },
    'SET_REWARDS': function (state, {data = [], meta = null} = {}) {
        state.rewards = data;
        state.rewardsMeta = meta;
    },
    'SET_LEVELS': function (state, levels = []) {
        state.levels = levels;
    },
    'SET_ERRORS': function (state, errors = {}) {
        state.errors = errors;
    }
};

export const actions = {
    profile: function ({commit, state}) {
        loading(commit);

        return state.service.fetchProfile().then(response => {
            commit('SET_PROFILE', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    events: function ({commit, state}, params = {}) {
        loading(commit);

        return state.service.fetchEvents(params).then(response => {
            commit('SET_EVENTS', {data: response.data, meta: response.meta || null});
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    rewards: function ({commit, state}, params = {}) {
        loading(commit);

        return state.service.fetchRewards(params).then(response => {
            commit('SET_REWARDS', {data: response.data, meta: response.meta || null});
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    levels: function ({commit, state}) {
        loading(commit);

        return state.levelService.fetchAll().then(response => {
            commit('SET_LEVELS', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    reportEvent: function ({commit, state}, payload) {
        const previous = state.profile ? Number(state.profile.total_vitality) : null;

        loading(commit);

        return state.service.reportEvent(payload).then(response => {
            commit('SET_PROFILE', response.data);
            commit('SET_ERRORS', {});
            loading(commit, false);

            const current = Number(response.data.total_vitality);

            return {
                profile: response.data,
                gained: previous === null ? 0 : current - previous,
                counted: previous === null || current > previous
            };
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    clearModule: function ({commit}) {
        commit('SET_PROFILE', null);
        commit('SET_EVENTS', {});
        commit('SET_REWARDS', {});
        commit('SET_LEVELS', []);
        commit('SET_ERRORS', {});
    }
};
